import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import ProfileAppModal from '../ProfileAppModal';
import '../../styles/BottomNavigation.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faBookmark, faUser } from '@fortawesome/free-solid-svg-icons';

// Helper function - show modal for all users accessing profile
const isUserLoggedInWithMobile = (user) => {
  // Show profile access modal for all users
  return true;
};

const MemberBottomNav = () => {
  const location = useLocation();
  const { currentUser } = useAuth();
  const [showProfileModal, setShowProfileModal] = useState(false);
  const { pathname } = location;

  const isActive = (path) => {
    if (path === '/') return pathname === '/dashboard' || pathname === '/';
    return pathname.startsWith(path);
  };

  const handleProfileClick = (e) => {
    e.preventDefault();
    // Check if user logged in with mobile number
    if (isUserLoggedInWithMobile(currentUser)) {
      setShowProfileModal(true);
    } else {
      // For non-mobile users, navigate to profile page
      window.location.hash = '#/profile';
    }
  };

  // Check if current user is a mobile user
  const isMobileUser = isUserLoggedInWithMobile(currentUser);

  return (
    <>
      <nav className="bottom-navigation">
        <Link to="/dashboard" className={`nav-item ${isActive('/') ? 'active' : ''}`}>
          <FontAwesomeIcon icon={faHome} className="nav-icon" />
          <span className="nav-text">Home</span>
        </Link>
        
        <Link to="/saved" className={`nav-item ${isActive('/saved') ? 'active' : ''}`}>
          <FontAwesomeIcon icon={faBookmark} className="nav-icon" />
          <span className="nav-text">Saved</span>
        </Link>
        
        {isMobileUser ? (
          // For mobile users, use a button instead of Link
          <button 
            className={`nav-item ${isActive('/profile') ? 'active' : ''}`}
            onClick={handleProfileClick}
            style={{ border: 'none', background: 'none' }}
          >
            <FontAwesomeIcon icon={faUser} className="nav-icon" />
            <span className="nav-text">Profile</span>
          </button>
        ) : (
          // For regular users, use normal Link
          <Link to="/profile" className={`nav-item ${isActive('/profile') ? 'active' : ''}`}>
            <FontAwesomeIcon icon={faUser} className="nav-icon" />
            <span className="nav-text">Profile</span>
          </Link>
        )}
      </nav>
      
      <ProfileAppModal 
        isOpen={showProfileModal}
        onClose={() => setShowProfileModal(false)}
      />
    </>
  );
};

export default MemberBottomNav;